// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"25803359","174":"c83bf12e","453":"c9a8e252","835":"22bfe50c"}[chunkId] + ".chunk.js";
};